type Props = {
  children: React.ReactNode;
};

const I18nProvider = ({ children }: Props) => {
  return <>{children}</>;
};

export { I18nProvider };
